import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { ToolPageLayout } from '../tool-page-layout/tool-page-layout';


@Component({
  selector: 'lib-generic-coming-soon',
  standalone: true,
  imports: [CommonModule, RouterModule, ToolPageLayout],
  template: `
    <lib-tool-page-layout [title]="toolTitle" [description]="toolDescription">
      <div class="flex flex-col gap-12">
        <!-- Coming Soon Hero -->
        <div class="flex items-center justify-center p-12 bg-indigo-50 dark:bg-indigo-900/20 border-2 border-dashed border-indigo-200 dark:border-indigo-800 rounded-3xl">
          <div class="text-center max-w-md">
            <div class="w-20 h-20 bg-indigo-100 dark:bg-indigo-900/50 rounded-full flex items-center justify-center mx-auto mb-6">
              <span class="text-4xl animate-bounce">🔐</span>
            </div>
            <h2 class="text-3xl font-bold mb-3 text-slate-900 dark:text-white">Secure Tool Coming Soon</h2>
            <p class="text-slate-600 dark:text-slate-400 mb-8 leading-relaxed">
              We're currently developing the <strong>{{ toolTitle }}</strong> processor. 
              Our focus is on 100% client-side security, ensuring your sensitive data never leaves your browser.
            </p>
            <div class="flex flex-col sm:flex-row gap-4 justify-center">
              <button class="px-8 py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700 transition shadow-lg shadow-indigo-200 dark:shadow-none">
                Notify Me on Release
              </button>
              <a routerLink="../" class="px-8 py-3 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-bold rounded-xl border border-slate-200 dark:border-slate-700 hover:bg-slate-50 transition">
                Explore Other Tools
              </a>
            </div>
          </div>
        </div>


      </div>
    </lib-tool-page-layout>
  `
})
export class GenericComingSoonComponent implements OnInit {
  private route = inject(ActivatedRoute);

  toolTitle = 'Coming Soon';
  toolDescription = 'This tool is currently under development.';


  ngOnInit() {
    this.route.data.subscribe(data => {
      this.toolTitle = data['title'] || 'Coming Soon';
      this.setupGuide(this.toolTitle);
    });
  }

  private setupGuide(title: string) {
    this.toolDescription = `The most powerful and secure way to handle ${title.toLowerCase()} directly in your browser.`;
  }
}
